import { provideHttpClient, withInterceptors } from '@angular/common/http';

import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
  APP_INITIALIZER
} from '@angular/core';

import { provideRouter } from '@angular/router';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { AuthTokenInterceptor } from '@app/core/interceptors/auth-token.interceptor';
import { GlobalErrorHandler } from '@app/core/services/error-handler.service';
import { routes } from '@app/app.routes';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateAdapterService } from './core/services/custom-date-adapter.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { loadRuntimeConfig } from './config-loader';

const MyPreset = definePreset(Aura, {
  semantic: {
    formField: {
      borderRadius: '0.375rem',
      focusRing: {
        // width?: string;
        // style?: string;
        // color: 'purple',
        // offset?: string;
        shadow: '0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25)'
      }
    },
    primary: {
      50: '#ffebe5',
      100: '#ffd7cc',
      200: '#ffaf9b',
      300: '#fc866c',
      400: '#f15840',
      500: '#e30613',
      600: '#b21712',
      700: '#841a11',
      800: '#58180e',
      900: '#2f1208',
      950: '#1e0c04'
    },
    disabledOpacity: 1,
    colorScheme: {
      light: {
        surface: {
          0: '#fff',
          50: '#fcfcfd',
          100: 'var(--bs-gray-100)',
          200: 'var(--bs-gray-200)',
          300: 'var(--bs-gray-300)',
          400: 'var(--bs-gray-400)',
          500: 'var(--bs-gray-500)',
          600: 'var(--bs-gray-600)',
          700: 'var(--bs-gray-700)',
          800: 'var(--bs-gray-800)',
          900: 'var(--bs-gray-900)',
          950: '#111315'
        },
        primary: {
          // color: '#e30613',
          // contrastColor: 'purple',
          // hoverColor: '#c10510'
          // activeColor: 'purple'
        },
        text: {
          color: 'var(--bs-body-color)'
          // hoverColor?: string;
          // mutedColor?: string;
          // hoverMutedColor?: string;
        },
        formField: {
          // background: ''
          disabledBackground: 'var(--bs-secondary-bg)',
          // filledBackground?: string;
          // filledHoverBackground?: string;
          // filledFocusBackground?: string;
          borderColor: 'var(--bs-border-color)',
          hoverBorderColor: 'var(--bs-border-color)',
          // focusBorderColor?: string;
          // invalidBorderColor?: string;
          color: 'var(--bs-body-color)',
          disabledColor: 'var(--bs-body-color)',
          // placeholderColor?: string;
          // invalidPlaceholderColor?: string;
          floatLabelColor: 'rgba(var(--bs-body-color-rgb), 0.65)',
          floatLabelFocusColor: 'rgba(var(--bs-body-color-rgb), 0.65)',
          // floatLabelActiveColor: 'purple',
          floatLabelInvalidColor: 'rgba(var(--bs-body-color-rgb), 0.65)',
          iconColor: 'var(--p-surface-600)',
          shadow: 'none'
        }
      }
    }
  },
  components: {
    iftalabel: {
      root: {
        positionX: '9px',
        fontSize: '0.85rem',
        fontWeight: '400'
      },
      input: {
        paddingBottom: '0',
        paddingTop: '16px'
      }
    },
    accordion: {
      content: {
        background: 'none'
      }
    },
    autocomplete: {
      optionGroup: {
        color: 'var(--bs-gray-600)'
      }
    }
  }
});

export function initConfig() {
  return () => loadRuntimeConfig();
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      multi: true
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([AuthTokenInterceptor])),
    importProvidersFrom(LoadingBarHttpClientModule),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: NgbDateAdapter, useClass: CustomDateAdapterService },
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false
        }
      },
      overlayOptions: {
        appendTo: 'body'
      }
    })
  ]
};
